import type { FC } from "react";
import emptyArt from "../assets/illustrations/empty-state.webp";
import { type EmptyStateAction, EmptyState } from "../persian/EmptyState";
import { PageHeader, PageSection } from "./PageHeader";

export interface RouteStubConfig {
    title: string;
    description: string;
    icon: FC<{ className?: string }>;
    emptyTitle: string;
    emptyDescription: string;
    /** What this page will hold once built. */
    points: string[];
    action?: EmptyStateAction;
}

/** Placeholder for a route that is not built yet: says what will be here and what to do meanwhile. */
export const RouteStub = ({ title, description, icon, emptyTitle, emptyDescription, points, action }: RouteStubConfig) => (
    <>
        <PageHeader title={title} description={description} />
        <PageSection>
            <div className="rounded-2xl bg-primary px-4 py-10 shadow-xs ring-1 ring-secondary ring-inset md:py-14">
                <EmptyState
                    icon={icon}
                    illustration={emptyArt}
                    title={emptyTitle}
                    description={emptyDescription}
                    points={points}
                    action={action}
                />
            </div>
        </PageSection>
    </>
);
